module.exports = __webpack_public_path__ + "static/media/jerryjones.3616fed2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/jerryjones.jpg
// module id = 24
// module chunks = 0